
import EventDetailsItem from "../events/event-details-item";
import RegistrationLineItem from "../events/registration-line-item";

import {
  defaultLayouts,
  GSLoadingSpinnerOverlay,
  defaultPadding,
  GSImage,
  defaultGapping,
  useMediaQuery,
  GSItemList,
} from "golfstatus_react_components";

import { useSelector } from "react-redux";
import {
  selectLoading,
  selectPublicTournament,
} from "../../reducers/tournamentSlice";
import { usePermissions } from "../../hooks/permissionHooks";
import { useGolfstatusNavigate } from "../../hooks/navigationHooks";

const TournamentDetailsWidget = (props) => {
  const navigate = useGolfstatusNavigate();

  const tournament = useSelector(selectPublicTournament);
  const loading = useSelector(selectLoading);

  const permissions = usePermissions();
  const { isPhone } = useMediaQuery();

  const getActionSection = () => {
    if (permissions?.packagesEnabled() || permissions?.donationsActive()) {
      return (
        <>
          <RegistrationLineItem
            registrationAction={{
              title: "register now",
              type: "black",
              onClick: () => {
                navigate("packages");
              },
            }}
            donationAction={{
              title: "make a donation",
              type: "black-border",
              onClick: () => {
                navigate("donate");
              },
            }}
          />
        </>
      );
    }

    return null;
  };

  const logo = tournament?.logo;
  const sponsorLogo = tournament?.sponsorLogo;
  const images = [logo];

  if (sponsorLogo) {
    images?.push(sponsorLogo);
  }

  const getImageSection = () => {
    return (
      <GSItemList
        type="vertical medium-gap"
        items={images}
        listItem={(image) => <GSImage src={image} />}
      />
    );
  };

  if (!tournament?.id && loading?.length > 0) {
    return (
      <GSLoadingSpinnerOverlay
        mainText="Loading..."
        style={{
          ...defaultLayouts.vStack.align("center", "center"),
          ...defaultPadding.emptyListPad,
          ...defaultLayouts.fill,
        }}
      />
    );
  }

  return (
    <div
      style={
        isPhone()
          ? {
              ...defaultLayouts.vStack.align("center", "center"),
              ...defaultLayouts.fullWidth,
              ...defaultGapping.xLargeGap,
            }
          : {
              ...defaultLayouts.hStack.align("center", "center"),
              ...defaultLayouts.fullWidth,
              ...defaultGapping.xLargeGap,
            }
      }
    >
      <div
        style={{
          ...defaultLayouts.vStack,
          ...defaultLayouts.fullWidth,
          ...defaultGapping.xLargeGap,
        }}
      >
        <EventDetailsItem {...tournament} />
        {getActionSection()}
      </div>
      <div style={{ ...defaultLayouts.fullWidth }}>{getImageSection()}</div>
    </div>
  );
};

export default TournamentDetailsWidget;
